export const JIELV_HOTEL_MAPPING_EXPORT_FIELDS = [
  { key: 'jielv_hotel_id', label: '推送 hotelId（InnID）', width: 22 },
  { key: 'inn_id', label: '系统 InnID', width: 18 },
  { key: 'hotel_name', label: '酒店名称', width: 28 },
  { key: 'hotel_address', label: '酒店地址', width: 42 },
  { key: 'jin_jiang_mapping', label: '锦江映射', width: 18 },
  { key: 'meituan_mapping', label: '美团映射', width: 18 },
  { key: 'ctrip_mapping', label: '携程映射', width: 18 },
  { key: 'eloon_mapping', label: '艺龙映射', width: 18 },
]

export function excelSafeValue(value) {
  if (value === null || value === undefined) return ''
  const text = String(value)
  return /^[=+\-@]/.test(text) ? "'" + text : text
}

export function selectedExportFields(keys) {
  const selected = new Set(keys || [])
  return JIELV_HOTEL_MAPPING_EXPORT_FIELDS.filter(field => selected.has(field.key))
}

export function buildJielvHotelMappingSheetRows(rows, keys) {
  const fields = selectedExportFields(keys)
  return [
    fields.map(field => field.label),
    ...(rows || []).map(row => fields.map(field => excelSafeValue(row[field.key]))),
  ]
}
